import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { disposeModal } from "../utils/modal-dispose.util"
// Connects to data-controller="bs-modal"
export default class extends Controller {
  connect() {
    const activeModals = document.querySelectorAll(".modal.show")
    this._isStacked = activeModals.length > 0

    if (!this._isStacked) {
      // Only clean up stale backdrops when no modal is currently showing
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    }

    this.modal = new Modal(this.element)
    this.modal.show()

    if (this._isStacked) {
      // Ensure child modal and its backdrop appear above the parent
      const zBase = 1060 + activeModals.length * 10
      this.element.style.zIndex = String(zBase)
      const backdrops = document.querySelectorAll(".modal-backdrop")
      if (backdrops.length > 0) {
        backdrops[backdrops.length - 1].style.zIndex = String(zBase - 5)
      }
    }

    this._hiddenHandler = (_event) => {
      document.dispatchEvent(new CustomEvent("modalRemoved"))
      this.element.remove()

      const remainingModals = document.querySelectorAll(".modal.show")
      if (remainingModals.length > 0) {
        // Parent modal still open — restore body state that Bootstrap removed
        document.body.classList.add("modal-open")
      } else {
        // No modals left — clean up any orphaned backdrops and body state
        document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
        document.body.classList.remove("modal-open")
        document.body.style.removeProperty("overflow")
        document.body.style.removeProperty("padding-right")
      }
    }
    this.element.addEventListener("hidden.bs.modal", this._hiddenHandler)

    // Bootstrap drops a hide() issued while the show transition runs, so a close requested during the fade-in (see
    // close()) is held until the modal has finished showing.
    this._shownHandler = () => {
      this._isShown = true
      if (this._closeRequested) this.modal?.hide()
    }
    this.element.addEventListener("shown.bs.modal", this._shownHandler)

    this._turboCacheHandler = () => {
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
      document.body.classList.remove("modal-open")
      document.body.style.removeProperty("overflow")
      document.body.style.removeProperty("padding-right")
      if (this.element) {
        this.element.remove()
      }
    }
    document.addEventListener("turbo:before-cache", this._turboCacheHandler)
  }

  // Closes the modal now, or the moment it has finished showing. A turbo-stream response can arrive while the dialog is
  // still fading in (the confirm button was pressed quickly): the change went through, and the dialog must not stay.
  close() {
    this._closeRequested = true
    if (this._isShown) this.modal?.hide()
  }

  disconnect() {
    if (this._hiddenHandler && this.element) {
      this.element.removeEventListener("hidden.bs.modal", this._hiddenHandler)
    }
    if (this._shownHandler && this.element) {
      this.element.removeEventListener("shown.bs.modal", this._shownHandler)
    }
    if (this._turboCacheHandler) {
      document.removeEventListener("turbo:before-cache", this._turboCacheHandler)
    }
    if (this.modal) {
      const modal = this.modal
      this.modal = null
      disposeModal(modal)
    }
  }
}
